'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 25, height: 25, viewBox: "0 0 25 25", fill: "none" }, props),
    React__namespace.createElement("path", { d: "M11.021 3.909a1.2 1.2 0 1 1 1.634 1.758l-5.719 5.314c-.342.319-.628.585-.866.815h16.6a1.2 1.2 0 1 1 0 2.4H5.997c.252.247.561.535.94.887l5.649 5.249a1.2 1.2 0 0 1-1.634 1.758l-5.706-5.303c-.689-.64-1.294-1.202-1.716-1.718-.456-.559-.825-1.211-.825-2.037s.37-1.478.825-2.036c.422-.517 1.027-1.08 1.715-1.719z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
